/**
 * Feature flags (Create React App: use REACT_APP_* — rebuild after changing .env).
 *
 * Each flag is read at build time. Defaults to off when unset or anything other than "true".
 *
 * Available flags:
 *   REACT_APP_SHOW_LANDING_FEATURES_CARD     — landing page features overview card
 *   REACT_APP_FEATURE_DEMO                   — "View demo" button and DemoShell
 *   REACT_APP_FEATURE_TRIAL_MATCHING          — AI trial matching (CVD/diabetes, FHIR)
 *   REACT_APP_FEATURE_SDOH_SCREENING          — PRAPARE/AHC-HRSN screening layer
 *   REACT_APP_FEATURE_FOOD_AS_MEDICINE        — produce Rx / MTM / SNAP-WIC referrals
 *   REACT_APP_FEATURE_DECENTRALIZED_TRIALS    — hybrid in-person/virtual + CHW visits
 *   REACT_APP_FEATURE_EQUITY_DASHBOARD        — diversity tracking vs FDA thresholds
 *   REACT_APP_FEATURE_SPONSOR_PORTAL          — pharma sponsor view (DAP, funnel, financials)
 */

function readBool(name) {
  const raw = process.env[name];
  return String(raw ?? "")
    .toLowerCase()
    .trim() === "true";
}

export function isLandingFeaturesCardEnabled() {
  return readBool("REACT_APP_SHOW_LANDING_FEATURES_CARD");
}

export function isDemoEnabled() {
  return readBool("REACT_APP_FEATURE_DEMO");
}

export function isTrialMatchingEnabled() {
  return readBool("REACT_APP_FEATURE_TRIAL_MATCHING");
}

export function isSDOHScreeningEnabled() {
  return readBool("REACT_APP_FEATURE_SDOH_SCREENING");
}

export function isFoodAsMedicineEnabled() {
  return readBool("REACT_APP_FEATURE_FOOD_AS_MEDICINE");
}

export function isDecentralizedTrialsEnabled() {
  return readBool("REACT_APP_FEATURE_DECENTRALIZED_TRIALS");
}

export function isEquityDashboardEnabled() {
  return readBool("REACT_APP_FEATURE_EQUITY_DASHBOARD");
}

export function isSponsorPortalEnabled() {
  return readBool("REACT_APP_FEATURE_SPONSOR_PORTAL");
}

export function isClinicianTriageViewEnabled() {
  return readBool("REACT_APP_CLINICIAN_TRIAGE_VIEW");
}

export function getEnabledFeatures() {
  return {
    trialMatching: isTrialMatchingEnabled(),
    sdohScreening: isSDOHScreeningEnabled(),
    foodAsMedicine: isFoodAsMedicineEnabled(),
    decentralizedTrials: isDecentralizedTrialsEnabled(),
    equityDashboard: isEquityDashboardEnabled(),
    sponsorPortal: isSponsorPortalEnabled(),
  };
}
